module.exports = __webpack_public_path__ + "img/CapeTip201810.94f49b6a.png";